<sc-no-data-container [hasData]="dataSource.data.length>0">
  <sc-scroll-pane>
    <table mat-table class="mat-table-selection" [dataSource]="dataSource">

      <ng-container matColumnDef="usageTimestamp">
        <th mat-header-cell *matHeaderCellDef>
          {{'usageTimestamp'| translate:['tmc.admin.rfidcardprotocol.table.usageTimestamp',
          translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.usageTimestamp}} </td>
      </ng-container>

      <ng-container matColumnDef="usageLocation">
        <th mat-header-cell *matHeaderCellDef>
          {{'usageLocation'| translate:['tmc.admin.rfidcardprotocol.table.usageLocation', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.usageLocation}} </td>
      </ng-container>

      <ng-container matColumnDef="rfidCardNumber">
        <th mat-header-cell *matHeaderCellDef>
          {{'rfidCardNumber'| translate:['tmc.admin.rfidcardprotocol.table.rfidCardNumber',
          translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.rfidCardNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="rfidCardTechnicalIdentifier">
        <th mat-header-cell *matHeaderCellDef>
          {{'rfidCardTechnicalIdentifier'| translate:['tmc.admin.rfidcardprotocol.table.rfidCardTechnicalIdentifier',
          translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.rfidCardTechnicalIdentifier}} </td>
      </ng-container>

      <ng-container matColumnDef="rfidCardDescription">
        <th mat-header-cell *matHeaderCellDef>
          {{'rfidCardDescription'| translate:['tmc.admin.rfidcardprotocol.table.rfidCardDescription',
          translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.rfidCardDescription}} </td>
      </ng-container>

      <ng-container matColumnDef="accessAllowed">
        <th mat-header-cell *matHeaderCellDef>
          {{'accessAllowed'| translate:['tmc.admin.rfidcardprotocol.table.accessAllowed', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.accessAllowed}} </td>
      </ng-container>

      <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let visit"></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

      <tr mat-row *matRowDef="let protocolEntry; columns: columnsToDisplay"></tr>

    </table>
  </sc-scroll-pane>
</sc-no-data-container>
